import { createAsyncThunk } from '@reduxjs/toolkit';
import { type EnabledDisabled } from '@reliance/types/enums/EnabledDisabled';
import resources from '../../resources';
import { loadBaseData } from '../actions/website';

export const changeTextingLocalStatus = createAsyncThunk(
  'facility/changeTextingLocalStatus',
  async (status: EnabledDisabled, thunkAPI) => {
    return resources.facility.putTextingLocalStatus(status).then(() => {
      thunkAPI.dispatch(loadBaseData());
    });
  },
);

export const changeCommunicationsEnabled = createAsyncThunk(
  'facility/changeCommunicationsEnabled',
  async (enabled: boolean, thunkAPI) => {
    return resources.facility.putCommunicationsEnabled(enabled).then(() => {
      thunkAPI.dispatch(loadBaseData());
    });
  },
);

export const changeAudioCallingEnabled = createAsyncThunk(
  'facility/changeAudioCallingEnabled',
  async (enabled: boolean, thunkAPI) => {
    return resources.facility.putAudioCallEnabled(enabled).then(() => {
      thunkAPI.dispatch(loadBaseData());
    });
  },
);

export const changeVideoCallingEnabled = createAsyncThunk(
  'facility/changeVideoCallingEnabled',
  async (enabled: boolean, thunkAPI) => {
    return resources.facility.putVideoCallEnabled(enabled).then(() => {
      thunkAPI.dispatch(loadBaseData());
    });
  },
);

export const changeMusicEnabled = createAsyncThunk(
  'facility/changeMusicEnabled',
  async (enabled: boolean, thunkAPI) => {
    return resources.facility.putMusicEnabled(enabled).then(() => {
      thunkAPI.dispatch(loadBaseData());
    });
  },
);

export const changeReferenceMaterialEnabled = createAsyncThunk(
  'facility/changeReferenceMaterialEnabled',
  async (enabled: boolean, thunkAPI) => {
    return resources.facility.putReferenceMaterialEnabled(enabled).then(() => {
      thunkAPI.dispatch(loadBaseData());
    });
  },
);
